export var IMarkLineLabelPosition;

!function(IMarkLineLabelPosition) {
    IMarkLineLabelPosition.start = "start", IMarkLineLabelPosition.startTop = "startTop", 
    IMarkLineLabelPosition.startBottom = "startBottom", IMarkLineLabelPosition.insideStart = "insideStart", 
    IMarkLineLabelPosition.insideStartTop = "insideStartTop", IMarkLineLabelPosition.insideStartBottom = "insideStartBottom", 
    IMarkLineLabelPosition.middle = "middle", IMarkLineLabelPosition.insideMiddleTop = "insideMiddleTop", 
    IMarkLineLabelPosition.insideMiddleBottom = "insideMiddleBottom", IMarkLineLabelPosition.end = "end", 
    IMarkLineLabelPosition.endTop = "endTop", IMarkLineLabelPosition.endBottom = "endBottom", 
    IMarkLineLabelPosition.insideEnd = "insideEnd", IMarkLineLabelPosition.insideEndTop = "insideEndTop", 
    IMarkLineLabelPosition.insideEndBottom = "insideEndBottom";
}(IMarkLineLabelPosition || (IMarkLineLabelPosition = {}));

export var IMarkAreaLabelPosition;

!function(IMarkAreaLabelPosition) {
    IMarkAreaLabelPosition.left = "left", IMarkAreaLabelPosition.right = "right", IMarkAreaLabelPosition.top = "top", 
    IMarkAreaLabelPosition.bottom = "bottom", IMarkAreaLabelPosition.topLeft = "topLeft", 
    IMarkAreaLabelPosition.topRight = "topRight", IMarkAreaLabelPosition.bottomLeft = "bottomLeft", 
    IMarkAreaLabelPosition.bottomRight = "bottomRight", IMarkAreaLabelPosition.middle = "middle", 
    IMarkAreaLabelPosition.insideLeft = "insideLeft", IMarkAreaLabelPosition.insideRight = "insideRight", 
    IMarkAreaLabelPosition.insideTop = "insideTop", IMarkAreaLabelPosition.insideBottom = "insideBottom", 
    IMarkAreaLabelPosition.insideTopLeft = "insideTopLeft", IMarkAreaLabelPosition.insideTopRight = "insideTopRight", 
    IMarkAreaLabelPosition.insideBottomLeft = "insideBottomLeft", IMarkAreaLabelPosition.insideBottomRight = "insideBottomRight";
}(IMarkAreaLabelPosition || (IMarkAreaLabelPosition = {}));

export var IMarkCommonArcLabelPosition;

!function(IMarkCommonArcLabelPosition) {
    IMarkCommonArcLabelPosition.arcInnerStart = "arcInnerStart", IMarkCommonArcLabelPosition.arcInnerEnd = "arcInnerEnd", 
    IMarkCommonArcLabelPosition.arcInnerMiddle = "arcInnerMiddle", IMarkCommonArcLabelPosition.arcOuterStart = "arcOuterStart", 
    IMarkCommonArcLabelPosition.arcOuterEnd = "arcOuterEnd", IMarkCommonArcLabelPosition.arcOuterMiddle = "arcOuterMiddle", 
    IMarkCommonArcLabelPosition.center = "center";
}(IMarkCommonArcLabelPosition || (IMarkCommonArcLabelPosition = {}));

export var IMarkPointItemPosition;

!function(IMarkPointItemPosition) {
    IMarkPointItemPosition.top = "top", IMarkPointItemPosition.bottom = "bottom", IMarkPointItemPosition.middle = "middle", 
    IMarkPointItemPosition.insideTop = "insideTop", IMarkPointItemPosition.insideBottom = "insideBottom", 
    IMarkPointItemPosition.insideMiddle = "insideMiddle";
}(IMarkPointItemPosition || (IMarkPointItemPosition = {}));
//# sourceMappingURL=type.js.map
